import { connect } from 'react-redux';
import NeighbourhoodWidget from 'components/widget/neighbourhood-life/NeighbourhoodWidget';
import { State } from 'store/state';
import { activeLivabilityCarouselIdxSelector } from 'store/state/insightsContext/selectors';
import { setActiveLivabilityCarousel, setActiveLivabilityCarouselIdx } from 'store/state/insightsContext/actions';
import { detailPageCategorySelector } from 'store/state/selectors/analytics';
import { insightsLoadingSelector } from 'store/state/domainData/selectors';
import { LivabilityCarouselDataSelectorByType } from '../quiet-streets';
import {
  isCollapsedInsightsSelector,
  showInsightsCarouselSelector,
} from 'store/state/selectors/insights/insightSections';


const mapStateToProps = (state: State) => ({
  eventCategory: detailPageCategorySelector(state),
  hideWidget: insightsLoadingSelector(state),
  carouselIdx: activeLivabilityCarouselIdxSelector(state),
  carouselData: LivabilityCarouselDataSelectorByType(state),
  isCollapsed: isCollapsedInsightsSelector(state),
  showCarousel: showInsightsCarouselSelector(state),
});

const mapDispatchToProps = {
  onReadMoreCarouselClick: setActiveLivabilityCarousel,
  setActiveCarouselIdx: setActiveLivabilityCarouselIdx,
};


export default connect(mapStateToProps, mapDispatchToProps)(NeighbourhoodWidget);
